import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import Benefits from "./Benefits/Benefits";
import PlansSection from "./PlansSection/PlansSection";
import FaqSection from "./FaqSection/FaqSection";
import ContactSection from "./ContactSection/ContactSection";
import CTASection from "./CTASection";
import workersImg from "./workers-tablet.png";
import companiesImg from "./companies-laptop.png";
import {
  userIcon,
  briefcaseIcon,
  paperPlaneIcon,
  calendarClockIcon,
  commentsIcon,
  bellIcon,
  buildingIcon,
  megaphoneIcon,
  inboxIcon,
  userMagnifyingGlassIcon,
} from "../../utils/icons";

export const workersItems = [
  {
    t: "Impulsa tu Carrera:",
    d: "Completa tu perfil y mantente visible, incluso si no estás buscando activamente. Restaurantes, bares, cafeterías y banqueteras podrán descubrirte y contactarte directamente para ofrecerte oportunidades laborales.",
    icon: userIcon,
  },
  {
    t: "Postula Sin Límites:",
    d: "Accede a cientos de ofertas de trabajo permanentes o temporales. Filtra por empresa, tipo de establecimiento, cargo, ubicación, beneficios, jornada, especialidad y más. Postula cuando quieras, cuantas veces quieras.",
    icon: briefcaseIcon,
  },
  {
    t: "Envía tu Currículum:",
    d: "¿Te interesa una empresa en particular? Envía tu currículum directamente aunque no haya ofertas publicadas. Hazte notar, demuestra tu interés y genera oportunidades.",
    icon: paperPlaneIcon,
  },
  {
    t: "Modo Reemplazo Urgente:",
    d: "Activa tu disponibilidad inmediata para cubrir reemplazos urgentes. Las empresas verán que estás listo para entrar al servicio y podrán contactarte en minutos para enfrentar contingencias.",
    icon: calendarClockIcon,
  },
  {
    t: "Chatea con Reclutadores:",
    d: "Habla directamente con quienes están contratando. Aclara condiciones, agenda entrevistas y construye relaciones desde el primer contacto.",
    icon: commentsIcon,
  },
  {
    t: "Recibe Alertas Personalizadas:",
    d: "Activa notificaciones inteligentes que te avisan cuando hay nuevas ofertas compatibles contigo, cuando un reclutador te escribe o cuando una empresa que te interesa publica una vacante.",
    icon: bellIcon,
  },
];

export const companiesItems = [
  {
    t: "Potencia tu Marca:",
    d: "Activa tu perfil de empresa, destaca los beneficios que ofreces, tu ambiente laboral y lo que hace único a tu equipo. Atrae talento mostrando por qué tu negocio es el mejor lugar para trabajar.",
    icon: buildingIcon,
  },
  {
    t: "Publica y Gestiona Ofertas de Empleo:",
    d: "Publica avisos y recibe postulaciones ilimitadas. Filtra, revisa perfiles detallados, selecciona y contacta candidatos desde un solo lugar.",
    icon: megaphoneIcon,
  },
  {
    t: "Recibe Proactivamente Currículums:",
    d: "Construye tu propia base de talentos. Recibe currículums de trabajadores interesados en tu empresa sin necesidad de publicar una vacante.",
    icon: inboxIcon,
  },
  {
    t: "Accede al Explorador de Talento:",
    d: "Explora activamente entre cientos de perfiles. Filtra por cargo, experiencia, ubicación y más. Invita directamente a los mejores candidatos a postular a tu equipo.",
    icon: userMagnifyingGlassIcon,
  },
  {
    t: "Contacto Directo con Candidatos:",
    d: "Chatea con postulantes para acelerar los procesos, resolver dudas y agendar entrevistas de manera eficiente y sin intermediarios.",
    icon: commentsIcon,
  },
  {
    t: "Alertas y Seguimiento Inteligente:",
    d: "Recibe notificaciones cuando lleguen nuevas postulaciones, mensajes, currículums espontáneos o cuando un candidato responda a tu contacto.",
    icon: bellIcon,
  },
];

const AboutUs = () => (
  <main className="about-page">
    <HeroSection />

    <Benefits
      title="Beneficios Trabajadores"
      items={workersItems}
      imgSrc={workersImg}
      ctaHref="/profesionales/crear"
    />

    <Benefits
      title="Beneficios Empresas"
      items={companiesItems}
      imgSrc={companiesImg}
      ctaHref="/empresas/crear"
    />

    <PlansSection />
    <FaqSection />
    <ContactSection />
    <CTASection />
  </main>
);
export default AboutUs;
